// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-3cpqGO"};